
import { mapState } from 'vuex'
import {
  mdiRvTruck,
  mdiAccount,
  mdiEmail,
  mdiStar,
  mdiFormatListBulleted,
  mdiTextBoxSearch,
  mdiPlaylistEdit,
  mdiSwapHorizontal,
  mdiCheckCircle,
  mdiExitToApp,
  mdiNewspaper,
  mdiMessageBadgeOutline,
  mdiCogOutline
} from '@mdi/js'
import WithTaskBadges from '@/components/ui/WithTaskBadges'

export default {
  name: 'Cm24DropDownMenu',
  components: {
    WithTaskBadges
  },
  props: {
    small: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    mdiRvTruck,
    mdiAccount,
    mdiEmail,
    mdiStar,
    mdiFormatListBulleted,
    mdiTextBoxSearch,
    mdiPlaylistEdit,
    mdiSwapHorizontal,
    mdiCheckCircle,
    mdiExitToApp,
    mdiNewspaper,
    mdiMessageBadgeOutline,
    mdiCogOutline
  }),
  computed: {
    ...mapState('settings', ['settings']),
    ...mapState('customer', {
      customerId: state => state.customer.entityId,
      customerEmail: state => state.customer.email,
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24 === true,
      merchantInReview: state => state.merchant?.merchantId && state.merchant?.acceptedByCm24 === null,
      privateProfileCompleted: state => state.customer.privateProfileCompleted,
      commercialProfileCompleted: state => state.customer.commercialProfileCompleted
    }),

    emailFromAuth () {
      return this.$auth?.user?.email
    }

  },

  methods: {
    deleteCm24Cookie () {
      try {
        document.cookie = 'cm24-uuid=; Max-Age=0; path=/; domain=' + location.hostname.replace('www', '') + ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
      } catch (e) {
        console.error('cannot remove cookie cm24-uuid')
      }

      this.$cookies.remove('cm24-uuid')
      this.$cookies.remove('X-Session-Id')
      this.$cookies.remove('funnel_20_unsubmitted')
    },
    async logout () {
      try {
        await this.$axios.put('/private/user-action/logout', {})

        if (window && window.chatbase) {
          window.chatbase('resetUser')
        }

        // Auth0 sends the user back to the start page with a full page load, so no
        // in-app navigation is needed here. auth-next would push the router to '/'
        // when loggedIn flips; that would start the landing page's fetch() only for
        // the navigation below to abort every request (Firefox logs those as CORS
        // failures with status null).
        this.$auth.options.redirect = false
        await this.$auth.logout()

        // this.deleteCm24Cookie()
        // const domain = location.hostname.replace('www', '')
        //   .replace('.staging', '')
        // const query = this.$route.query
        // const $axios = this.$axios
        // const $cookies = this.$cookies
        // await this.$store.dispatch('initCm24Uuid', { query, $axios, $cookies, domain })

        // console.log(this.$cookies.get('cm24-uuid'))

        // must stay the last statement: nothing may run into a page that is leaving
        const logoutRedirectUri = location.protocol + '//' + location.host
        window.location.href = `https://${this.$config.auth0Domain}/v2/logout?client_id=${this.$config.auth0ClientId}&returnTo=${logoutRedirectUri}`
      } catch (e) {
        console.error(e)
      }
    }
  }
}
